import React from 'react';
import './LoadingOverlay.css';

const LoadingOverlay = ({ message }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-overlay__backdrop" />
      <div className="loading-overlay__content">
        <div className="loading-overlay__spinner" />
        {message && <p className="loading-overlay__message">{message}</p>}
      </div>
    </div>
  );
};

export default LoadingOverlay;
